import moment from "moment";
import React from "react";
import { getCurrentFinancialYear } from "../../CommonMethhods/CommonMethods";

export default function MFDuration(props) {
  let setCustomShow = props.setCustomShow;
  let setFromDate = props.setFromDate;
  let setToDate = props.setToDate;
  let setToDateError = props.setToDateError;
  let setFromDateError = props.setFromDateError;

  const currFYear = new Date().getFullYear();
  const lastFYear = currFYear - 1;
  const secondLastFYear = currFYear - 2;

  const onChangeDuration = (e) => {
    let val = e.target.value;
    setFromDateError(false);
    setToDateError(false);

    let date = new Date();
    let firstDay = "";
    let lastDay = "";

    if (val == "custom") {
      setCustomShow(true);
    } else if (val == "last3mnths") {
      setCustomShow(false);
      let firstVal = new Date(
        date.getFullYear(),
        date.getMonth() - 3,
        date.getDate()
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date();
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val == "last6mnths") {
      setCustomShow(false);
      let firstVal = new Date(
        date.getFullYear(),
        date.getMonth() - 6,
        date.getDate()
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date();
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val == "currentyr") {
      setCustomShow(false);
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear(),
        currentFyearStart.getMonth(),
        1
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");

      let lastVal = new Date();
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val == "lastyr") {
      setCustomShow(false);
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear() - 1,
        currentFyearStart.getMonth(),
        1
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date(
        currentFyearEnd.getFullYear() - 1,
        currentFyearEnd.getMonth(),
        31
      );
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val === "secondlastyr") {
      setCustomShow(false);
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear() - 2,
        currentFyearStart.getMonth(),
        1
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date(
        currentFyearEnd.getFullYear() - 2,
        currentFyearEnd.getMonth(),
        31
      );
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val === "tillDate") {
      setCustomShow(false);
      setFromDate("");
      setToDate("");
    } else {
      setCustomShow(false);
    }
    setFromDate(firstDay);
    setToDate(lastDay);
  };
  return (
    <div>
      <label className="form-label">Select Duration</label>

      <select
        onChange={onChangeDuration}
        className={props.className ? props.className : ""}
      >
        <option value="">Please Select</option>
        <option value="last3mnths">Last 3 Months</option>
        <option value="last6mnths">Last 6 Months</option>
        <option value="tillDate">Till Date</option>
        <option value="currentyr">{"FY " + currFYear}</option>
        <option value="lastyr">{"FY " + lastFYear}</option>
        <option value="secondlastyr">{"FY " + secondLastFYear}</option>
        <option value="custom">Custom</option>
      </select>
    </div>
  );
}
